
import {Cloudinary} from "@cloudinary/url-gen";

// Créez votre instance Cloudinary
const cld = new Cloudinary({
  cloud: {
    cloud_name: 'dodsr1s0d',
    api_key: '328927441826894',
    api_secret: 'RmG3Hips5ISldmwjaCDKu72L4R4'  },
  url: {
    secure: true // Utiliser HTTPS
  }
});

export default cld;
